"use client"

import { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import { doc, getDoc } from "firebase/firestore"
import { db } from "../../firebase" // Adjust the path as needed
import CountryHero from "../../components/CountryHero"
import CountryTabs from "../../components/CountryTabs"
import TabContent from "../../components/TabContent"
import "./country.css"

const Country = () => {
  const { id } = useParams()
  // const id = 'united-kingdom' // Hardcoded for testing, replace with useParams() in production
  const [activeTab, setActiveTab] = useState("FAST FACTS")
  const [countryData, setCountryData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  // Format the country name for display (capitalize first letter of each word)
  const formatCountryName = (name) => {
    return name
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")
  }

   const fetchCountryData = async () => {
      try {
        setLoading(true)
        // Normalize the ID to match Firestore document IDs
        const countryId = id.toLowerCase().replace(/\s+/g, "-")
        console.log("Fetching data for country ID:", countryId)
        const countryRef = doc(db, "countries", countryId)
        const countrySnap = await getDoc(countryRef)

        if (countrySnap.exists()) {
          setCountryData({ id: countrySnap.id, ...countrySnap.data() })
          console.log("Country data fetched:", countrySnap.data())
        } else {
          // If country not found in Firestore, use default data
          setCountryData({
            id: countryId,
            name: formatCountryName(id),
            flagUrl: `https://cdn-icons-png.flaticon.com/128/197/${getCountryFlagCode(id)}.png`,
            // Add default data for other sections as needed
          })
        }
      } catch (err) {
        console.error("Error fetching country data:", err)
        setError("Failed to load country data")
      } finally {
        setLoading(false)
      }
    }

    // Helper function to get flag code based on country name
    const getCountryFlagCode = (countryName) => {
      const flagCodes = {
        uk: "197374",
        usa: "197484",
        ireland: "197567",
        canada: "197430",
        germany: "197571",
        dubai: "197558",
        france: "197560",
        europe: "197615",
        italy: "197626",
        netherlands: "197441",
        poland: "197529",
        spain: "197593",
        australia: "197507",
        "new-zealand": "197589",
        // Add more countries as needed
      }
       return flagCodes[countryName.toLowerCase()] || "197374" // Default to UK flag
    }

  useEffect(() => {
 

    if (id) {
      fetchCountryData()
    }
  }, [])

  if (loading) {
    return <div className="loading-container">Loading...</div>
  }

  if (error) {
    return <div className="error-container">{error}</div>
  }

  return (
    <div className="country-container">
      {/* Hero Section with Background Image */}
      <CountryHero
        country={countryData.name || formatCountryName(id)}
        flagUrl={countryData.flagUrl}
        heroImage={countryData.heroImage}
      />

      {/* Tabs Navigation */}
      <CountryTabs
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        country={countryData.name || formatCountryName(id)}
      />

      {/* Tab Content */}
      <TabContent activeTab={activeTab} countryData={countryData} />

      {/* WhatsApp Button */}
      <a href="https://wa.me/1234567890" className="whatsapp-button" target="_blank" rel="noopener noreferrer">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="white">
          <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
        </svg>
      </a>
    </div>
  )
}

export default Country
